import { INotesComponent, Notes } from '@modeso/types__aumico-lib-annualreport-be';

export interface INotesAccordionComponent extends INotesComponent {
    previousYearData?: Notes;
}
